import {ProductPropertiesPane} from '../components/NodePropertiesPane.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Model from './ModelDes.mjs'
import ButtonExportReqConfirm from './PropertiesPaneButtonExportReqConfirm.jsx'

export default function PropertiesPaneDes(props) {
    return (
        <ProductPropertiesPane
            buttons={<ButtonExportReqConfirm />}

            controllers={
                <>
                    <Text prop="desNo" />
                    <Text prop="desTitle" />
                    <Text prop="taskNo" />
                </>
            }

            Model={Model}
            sn={null}
            {...props}
        />
    )
}
